export default __webpack_public_path__ + "static/media/14.cfc6afc1.png";